import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { addCourtroom } from 'slices/courtroomSlice';
import { updateCourtroom } from 'slices/courtroomSlice';
import toast from 'react-hot-toast';
import { courtroomSelector } from 'slices/courtroomSlice';
import { setError } from 'slices/courtroomSlice';
import ErrorMessage from 'components/common/ErrorMessage';
import { CustomSwitch } from 'components/common/Switch';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import { fetchCourtrooms } from 'slices/courtroomSlice';

const AddCourtroomsForm = ({ item, handleClose, callback, statusPerm }) => {
  const { handleSubmit, formState: { errors }, control, setValue, } = useForm();
  const dispatch = useDispatch();
  const { error, loader } = useSelector(courtroomSelector);
  const [byZoom, setByZoom] = useState(false);

  useEffect(() => {
    setValue('name', item?.name || '');
    setValue('zoom', item?.zoom || '');
    setValue('zoom_link', item?.zoom_link || '');
    setByZoom(item?.zoom);
    setValue('status', (typeof (item?.status) == "number") ? item?.status : 1)
    return () => {
      dispatch(setError({}))
      setValue("name", "");
      setValue('zoom', '');
      setValue('zoom_link', '');
      setByZoom('');
      setValue("status", 1)
    }
  }, [item])

  useEffect(() => {
    if (!byZoom) {
      setValue("zoom_link", "");
    }
  }, [byZoom, setValue]);



  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
        className: "successToast",
      })
      dispatch(fetchCourtrooms())
      handleClose()
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {

    const newData = {
      ...data,
      zoom: byZoom,
    };

    dispatch(setError({}))
    if (item?.id) {
      dispatch(updateCourtroom(newData, item?.id, submitCallback));
    } else {
      dispatch(addCourtroom(newData, submitCallback));
    }
  }
  return (
    <form onSubmit={handleSubmit(onSubmit)}>

      <div className="row-primary">
        <h2>Courtroom name *</h2>

        <Controller
          name="name"
          control={control}
          render={({ field }) => <input className="input-in type_inp" type="text" name='name' placeholder='Name' required {...field} />}
        />
      </div>

      <div className="row-primary template_switch align-items-center">
        <h2 className="m-0">Zoom</h2>
        <label className="custom-checkbox checkbox">
          <input
            type="checkbox"
            name="zoom"
            checked={byZoom === 1 ? true : false}
            onChange={(e) => {
              const zoomEnabled = e.target.checked ? 1 : 0;
              setByZoom(zoomEnabled);
              if (!zoomEnabled) {
                setValue("zoom_link", "");
              }
            }}
          />
          <span className="checkmark"></span>
        </label>
      </div>
      {byZoom ?
      <div className="row-primary">
        <h2>Zoom Link</h2>
        <Controller
          name="zoom_link"
          control={control}
          render={({ field }) => (
            <textarea
              className="type_inp input-in"
              {...field}
              placeholder="Zoom Link"
            ></textarea>
          )}
        />
      </div>
      : null
      }
    <br />
    <br />
      {statusPerm &&
        <div className="row-primary flex-row align-items-center" style={{ alignItems: "center" }}>
          <h2 className='mt-0'>Status</h2>
          <Controller
            name="status"
            control={control}
            required
            rules={{
              required: true
            }}
            render={({ field }) => (
              <CustomSwitch
                labelText="active"
                checked={field.value == 1 ? true : false}
                handleChange={(checked) => field.onChange(checked ? 1 : 0)}

              />
            )}
          />
        </div>
      }
      {error?.errors?.name?.map((error) => (
        <div style={{ marginBottom: 10 }}>
          <ErrorMessage text={error} />
        </div>
      ))}

      <div className="Form-footer">
        <button type="button" className="Cancle_button" data-bs-dismiss="modal">Cancel</button>
        <SubmitButton
          loader={loader}
          btnText={item?.id ? "Update" : "Create"}
        />
      </div>
    </form>
  )
}

const AddCourtrooms = ({ item, onClose, callback, statusPerm }) => {
  return (
    <div className={`modal fade`} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <div></div>
            <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Courtrooms</h5>
            <button onClick={onClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body modal_form_body">
            <AddCourtroomsForm item={item} handleClose={onClose} callback={callback} statusPerm={statusPerm} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddCourtrooms
